import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  @Input() team_member: any;

  current_password = '';
  new_password = '';
  confirm_password = '';
  saving = false;
  confirmed = false;

  show_current = false;
  show_new = false;
  show_confirm = false;

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService
  ) {}

  ngOnInit() {}

  get passwordsMatch(): boolean {
    return !this.confirm_password || this.new_password === this.confirm_password;
  }

  get canSubmit(): boolean {
    return !this.saving &&
      !!this.current_password &&
      this.globalService.validatePassword(this.new_password).valid &&
      this.new_password === this.confirm_password;
  }

  async Submit() {
    if (!this.canSubmit) return;
    this.saving = true;
    try {
      const data: any = await this.apiService.put(
        `team_members/${this.team_member.guid}/password`,
        {
          current_password: this.current_password,
          new_password: this.new_password,
          confirm_password: this.confirm_password,
        }
      );

      // Endpoint delegates to LoginReturn which returns { success: "1", user: "..." }
      const success = data.success === '1' || data.success === true;
      if (!success) {
        this.globalService.presentToastMessage(data.message || 'Failed to update password.', false);
        return;
      }

      console.log(data);

      this.confirmed = true;
    } catch {
      this.globalService.presentToastMessage('Failed to update password.', false);
    } finally {
      this.saving = false;
    }
  }

  async Close() {
    this.modalController.dismiss(this.confirmed);
  }
}
